/**
 * SEO utilities - base URL for canonical, og:url, sitemap
 * Set REACT_APP_SITE_URL in .env for production (e.g. https://app.majestify.com)
 */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '');

export function buildUrl(path) {
  const base = SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base.replace(/\/$/, '')}${p}` : '';
}
